var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markdown-editor"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.label,
      "errors": _vm.internalErrors
    },
    on: {
      "focus": _vm.focus
    }
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('div', {
    staticClass: "uk-grid-match uk-child-width-1-2@s",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', [_c('textarea', {
    ref: "primaryInput",
    staticClass: "uk-textarea",
    class: _vm.inputCss,
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "rows": _vm.rows
    },
    domProps: {
      "value": _vm.internalValue
    },
    on: {
      "input": _vm.onInput
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "preview uk-background-muted uk-padding-small",
    domProps: {
      "innerHTML": _vm._s(_vm.compiledMarkdown)
    }
  })])])])]), _vm._v(" "), _c('markdown-quick-reference')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-764f8212","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/MarkdownEditor.vue
// module id = 2062
// module chunks = 0